/**
 * @generated SignedSource<<9ae79ec4a9d1dbaa6267aed6ca124a6a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ResetUserMutation$variables = {
  userId: string;
};
export type ResetUserMutation$data = {
  readonly adminResetUser: {
    readonly __typename: "AdminUserReset";
    readonly success: boolean;
  } | {
    readonly __typename: "ForbiddenError";
    readonly reason: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type ResetUserMutation = {
  response: ResetUserMutation$data;
  variables: ResetUserMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "adminResetUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "success",
            "storageKey": null
          }
        ],
        "type": "AdminUserReset",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "reason",
            "storageKey": null
          }
        ],
        "type": "ForbiddenError",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ResetUserMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ResetUserMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c966b761d2fe57535f79318cce7eb090",
    "id": null,
    "metadata": {},
    "name": "ResetUserMutation",
    "operationKind": "mutation",
    "text": "mutation ResetUserMutation(\n  $userId: ID!\n) {\n  adminResetUser(userId: $userId) {\n    __typename\n    ... on AdminUserReset {\n      success\n    }\n    ... on ForbiddenError {\n      reason\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "41c819e4ef1dd1ddddb60644f67c3fee";

export default node;
